import { inject, Service } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

/*
 * Custom title strategy for translating static titles that are provided by the title property in the route configuration.
 * For updating the title dynamically, use the AppTitle per component.
 */
@Service({ autoProvided: false })
export class CustomTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly translateService = inject(TranslateService);

  private readonly defaultTitle: string = 'CORE.APP-NAME';

  private titleKeys: string[] = [];

  override updateTitle(routerState: RouterStateSnapshot): void {
    this.titleKeys = [this.defaultTitle];
    const title = this.buildTitle(routerState);
    if (!title) {
      this.title.setTitle(this.translateService.instant(this.defaultTitle));
      return;
    }
    this.titleKeys.unshift(title);
    const translatedTitle = this.titleKeys.map(key => this.translateService.instant(key)).join(' – ');

    this.title.setTitle(translatedTitle);
  }
}
